// @ts-ignore - env module is dynamically loaded
import env from "env";

/**
 * Get the WebSocket URL for ActionCable connection
 * Converts the GraphQL HTTP/HTTPS URL to WS/WSS protocol
 * 
 * @returns WebSocket URL (e.g., "wss://api.trafica.co.za/cable")
 */
export function getWebSocketUrl(): string {
    const graphqlUri = env.GRAPHQL_URI || "https://api.trafica.co.za/graphql";
    const wsUri = graphqlUri
        .replace(/^https?:\/\//, (match) =>
            match === "https://" ? "wss://" : "ws://"
        )
        .replace("/graphql", "");
    return `${wsUri}/cable`;
}

